import { render } from "./sectiona.vue?vue&type=template&id=a563a0be"
import script from "./sectiona.vue?vue&type=script&lang=js"
export * from "./sectiona.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__